import { Form, Input, InputNumber, Radio, Select } from "antd";
import { useEffect } from "react";
import { deviceType, labelType, payType, vipType } from "../const";

export default function VIPPackageForm({ form, item }: any) {
    useEffect(() => {
        if (item.id) {
            form.setFieldsValue(item);
            form.setFieldValue('discountPrice', item.discountPrice / 100);
            form.setFieldValue('realPrice', item.realPrice / 100);
            form.setFieldValue('strikethroughPrice', item.strikethroughPrice / 100);
        }
    }, []);

    return (
        <Form form={form} size="small" name="VIPPackageForm" className='vip-package-form' labelCol={{ span: 6 }} wrapperCol={{ span: 15 }} autoComplete="off">
            <Form.Item label="会员卡标题" name="title" rules={[{ required: true, message: '不能为空' }]}>
                <Input placeholder="请输入会员卡标题" />
            </Form.Item>
            <Form.Item label="标签类型" name="labelType" rules={[{ required: true, message: '不能为空' }]} initialValue={true}>
                <Radio.Group
                    options={Object.entries(labelType).map(([key, value]) => ({
                        label: value.text,
                        value: key,
                    }))}
                />
            </Form.Item>
            <Form.Item label="会员卡底部文案" name="bottomText" rules={[{ required: true, message: '不能为空' }]}>
                <Input placeholder="请输入会员卡底部文案" />
            </Form.Item>
            <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) => prevValues.deviceType !== currentValues.deviceType}
            >
                {({ getFieldValue }) => {
                    const currentDeviceType = getFieldValue('deviceType');
                    const isIos = currentDeviceType === 'IOS';
                    return (
                        <Form.Item
                            label="苹果商品编码"
                            name="appleCode"
                            rules={[
                                ...(isIos ? [{ required: true, message: '不能为空' }] : [])
                            ]}
                        >
                            <Input placeholder="请输入苹果商品编码" />
                        </Form.Item>
                    );
                }}
            </Form.Item>
            <Form.Item label="会员卡类型" name="vipType" rules={[{ required: true, message: '不能为空' }]}>
                <Select
                    placeholder="请选择会员卡类型"
                    options={Object.entries(vipType).map(([key, value]) => ({
                        label: value.text,
                        value: key,
                    }))}
                    onChange={() => form.validateFields(['minVersionCode'])}
                />
            </Form.Item>
            <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.vipType !== currentValues.vipType}>
                {() => {
                    const timeUnits = { DATE: '日', MONTH: '月', YEAR: '年' };
                    const currentVipType = form.getFieldValue('vipType') as keyof typeof timeUnits;
                    if (currentVipType && timeUnits[currentVipType]) {
                        return (
                            <Form.Item
                                label="生效时间"
                                name="vipValue"
                                rules={[{ required: true, message: '不能为空' }]}
                            >
                                <InputNumber
                                    min={1}
                                    precision={0}
                                    placeholder="请输入整数"
                                    style={{ width: '100%' }}
                                    addonAfter={timeUnits[currentVipType]}
                                />
                            </Form.Item>
                        );
                    }

                    return null;
                }}
            </Form.Item>
            <Form.Item label="支付方式" name="payType" rules={[{ required: true, message: '不能为空' }]}>
                <Select
                    mode="multiple"
                    placeholder="请选择支付方式"
                    options={Object.entries(payType)
                        .filter(([key]) => key !== 'APPLE_AUTO')
                        .map(([key, value]) => ({
                            label: value.text,
                            value: key,
                        }))}
                />
            </Form.Item>
            <Form.Item label="适用平台" name="deviceType" rules={[{ required: true, message: '不能为空' }]}>
                <Radio.Group
                    options={Object.entries(deviceType).map(([key, value]) => ({
                        label: value.text,
                        value: key,
                    }))}
                />
            </Form.Item>
            <Form.Item
                label="最低 App build"
                name="minVersionCode"
                extra="留空表示不限制。当前 App Store 旧版为 35，订阅新版为 36。"
                rules={[
                    {
                        validator: async (_, value) => {
                            const continuousTypes = [
                                'CONTINUOUS_MONTHLY',
                                'CONTINUOUS_QUARTERLY',
                                'CONTINUOUS_YEARLY',
                            ];
                            const currentVipType = form.getFieldValue('vipType');
                            if (continuousTypes.includes(currentVipType) && (!value || value < 36)) {
                                throw new Error('连续订阅套餐最低 App build 必须为 36 或以上');
                            }
                        },
                    },
                ]}
            >
                <InputNumber
                    min={1}
                    precision={0}
                    placeholder="例如 36"
                    style={{ width: '100%' }}
                    onChange={() => form.validateFields(['maxVersionCode'])}
                />
            </Form.Item>
            <Form.Item
                label="最高 App build"
                name="maxVersionCode"
                rules={[
                    {
                        validator: async (_, value) => {
                            const minVersion = form.getFieldValue('minVersionCode');
                            if (value && minVersion && value < minVersion) {
                                throw new Error('最高 App build 不能小于最低 App build');
                            }
                        },
                    },
                ]}
            >
                <InputNumber min={1} precision={0} placeholder="例如 35" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="优惠价格" name="discountPrice" rules={[{ required: true, message: '不能为空' }]}>
                <InputNumber placeholder="请输入优惠价格" precision={2} style={{ width: '100%' }} addonAfter={'元'} />
            </Form.Item>
            <Form.Item label="真实价格" name="realPrice" rules={[{ required: true, message: '不能为空' }]}>
                <InputNumber placeholder="请输入真实价格" precision={2} style={{ width: '100%' }} addonAfter={'元'} />
            </Form.Item>
            <Form.Item label="划线价" name="strikethroughPrice" rules={[{ required: true, message: '不能为空' }]}>
                <InputNumber placeholder="请输入划线价" precision={2} style={{ width: '100%' }} addonAfter={'元'} />
            </Form.Item>
            <Form.Item label="排序" name="sort" rules={[{ required: true, message: '不能为空' }]}>
                <InputNumber placeholder="请输入排序" precision={0} style={{ width: '100%' }} />
            </Form.Item>
        </Form>
    )
}
